// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.connector-selection {
  max-width: 1000px;
  margin: 0 auto;
  padding: 2rem;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  background: #fff;
}

.connector-selection-header {
  text-align: center;
  margin-bottom: 3rem;
  text-align: center;
  margin-bottom: 3rem;
  justify-content: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.connector-selection-header h1 {
  font-size: 2.5rem;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 1rem;
}

.connector-selection-header p {
  font-size: 1.1rem;
  color: #6b7280;
  margin-bottom: 0.5rem;
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  gap: 1rem;
}

.loading-container h2 {
  color: #374151;
  margin: 0;
}

.loading-container p {
  color: #6b7280;
  margin: 0;
}

.connector-options {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  margin-bottom: 3rem;
}

.connector-card {
  background: white;
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  padding: 2rem;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: flex-start;
  gap: 1.5rem;
}

.connector-card:hover {
  border-color: #3b82f6;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.15);
}

.connector-card.selected {
  border-color: #3b82f6;
  background: #f0f9ff;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.15);
}

.connector-card.disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.connector-checkbox {
  flex-shrink: 0;
  margin-top: 0.25rem;
}

.connector-checkbox input[type="radio"] {
  width: 20px;
  height: 20px;
  accent-color: #3b82f6;
}

.connector-content {
  flex: 1 1;
}

.connector-logos {
  display: flex;
  align-items: center;
  gap: 2rem;
  margin-bottom: 1.5rem;
}

.connector-logo {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
}

.connector-logo img {
  width: 48px;
  height: 48px;
  object-fit: contain;
}

.platform-name {
  font-size: 0.9rem;
  font-weight: 500;
  color: #374151;
}

.connector-arrow {
  color: #6b7280;
}

.connector-details h3 {
  font-size: 1.3rem;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 0.75rem;
}

.connector-details p {
  color: #6b7280;
  line-height: 1.6;
  margin: 0;
}

.unavailable-badge {
  display: inline-block;
  background: #fbbf24;
  color: #92400e;
  padding: 0.25rem 0.75rem;
  border-radius: 12px;
  font-size: 0.8rem;
  font-weight: 500;
  margin-top: 0.75rem;
}

.connector-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 2rem;
  border-top: 1px solid #e5e7eb;
}

.cancel-button {
  background: #f9fafb;
  color: #374151;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 0.75rem 2rem;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.cancel-button:hover {
  background: #f3f4f6;
  border-color: #9ca3af;
}

.next-button {
  background: #3b82f6;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 0.75rem 2rem;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.next-button:hover:not(:disabled) {
  background: #2563eb;
}

.next-button:disabled {
  background: #9ca3af;
  cursor: not-allowed;
}

/* Responsive Design */
@media (max-width: 768px) {
  .connector-selection {
    padding: 1rem;
  }

  .connector-selection-header h1 {
    font-size: 2rem;
  }

  .connector-card {
    flex-direction: column;
    text-align: center;
  }

  .connector-logos {
    justify-content: center;
  }

  .connector-actions {
    flex-direction: column;
    gap: 1rem;
  }

  .cancel-button,
  .next-button {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Connector-Screen/ConnectorSelection/ConnectorSelection.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,8EAA8E;EAC9E,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,SAAS;AACX;;AAEA;EACE,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,wBAAwB;EACxB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;;IAEE,WAAW;EACb;AACF","sourcesContent":[".connector-selection {\n  max-width: 1000px;\n  margin: 0 auto;\n  padding: 2rem;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif;\n  background: #fff;\n}\n\n.connector-selection-header {\n  text-align: center;\n  margin-bottom: 3rem;\n  text-align: center;\n  margin-bottom: 3rem;\n  justify-content: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.connector-selection-header h1 {\n  font-size: 2.5rem;\n  font-weight: 600;\n  color: #1f2937;\n  margin-bottom: 1rem;\n}\n\n.connector-selection-header p {\n  font-size: 1.1rem;\n  color: #6b7280;\n  margin-bottom: 0.5rem;\n}\n\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 400px;\n  gap: 1rem;\n}\n\n.loading-container h2 {\n  color: #374151;\n  margin: 0;\n}\n\n.loading-container p {\n  color: #6b7280;\n  margin: 0;\n}\n\n.connector-options {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n  margin-bottom: 3rem;\n}\n\n.connector-card {\n  background: white;\n  border: 2px solid #e5e7eb;\n  border-radius: 12px;\n  padding: 2rem;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: flex-start;\n  gap: 1.5rem;\n}\n\n.connector-card:hover {\n  border-color: #3b82f6;\n  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.15);\n}\n\n.connector-card.selected {\n  border-color: #3b82f6;\n  background: #f0f9ff;\n  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.15);\n}\n\n.connector-card.disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.connector-checkbox {\n  flex-shrink: 0;\n  margin-top: 0.25rem;\n}\n\n.connector-checkbox input[type=\"radio\"] {\n  width: 20px;\n  height: 20px;\n  accent-color: #3b82f6;\n}\n\n.connector-content {\n  flex: 1;\n}\n\n.connector-logos {\n  display: flex;\n  align-items: center;\n  gap: 2rem;\n  margin-bottom: 1.5rem;\n}\n\n.connector-logo {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.connector-logo img {\n  width: 48px;\n  height: 48px;\n  object-fit: contain;\n}\n\n.platform-name {\n  font-size: 0.9rem;\n  font-weight: 500;\n  color: #374151;\n}\n\n.connector-arrow {\n  color: #6b7280;\n}\n\n.connector-details h3 {\n  font-size: 1.3rem;\n  font-weight: 600;\n  color: #1f2937;\n  margin-bottom: 0.75rem;\n}\n\n.connector-details p {\n  color: #6b7280;\n  line-height: 1.6;\n  margin: 0;\n}\n\n.unavailable-badge {\n  display: inline-block;\n  background: #fbbf24;\n  color: #92400e;\n  padding: 0.25rem 0.75rem;\n  border-radius: 12px;\n  font-size: 0.8rem;\n  font-weight: 500;\n  margin-top: 0.75rem;\n}\n\n.connector-actions {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-top: 2rem;\n  border-top: 1px solid #e5e7eb;\n}\n\n.cancel-button {\n  background: #f9fafb;\n  color: #374151;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  padding: 0.75rem 2rem;\n  font-size: 1rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.cancel-button:hover {\n  background: #f3f4f6;\n  border-color: #9ca3af;\n}\n\n.next-button {\n  background: #3b82f6;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  padding: 0.75rem 2rem;\n  font-size: 1rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.next-button:hover:not(:disabled) {\n  background: #2563eb;\n}\n\n.next-button:disabled {\n  background: #9ca3af;\n  cursor: not-allowed;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .connector-selection {\n    padding: 1rem;\n  }\n\n  .connector-selection-header h1 {\n    font-size: 2rem;\n  }\n\n  .connector-card {\n    flex-direction: column;\n    text-align: center;\n  }\n\n  .connector-logos {\n    justify-content: center;\n  }\n\n  .connector-actions {\n    flex-direction: column;\n    gap: 1rem;\n  }\n\n  .cancel-button,\n  .next-button {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
